import type { ReconciliationCardSummary, ReconciliationGridRow } from "./reconciliationGridTypes";
import { ReconciliationRowStates } from "./reconciliationGridTypes";

export function computeReconciliationCardSummary(gridRows: ReconciliationGridRow[]): ReconciliationCardSummary {
    let alignedCount = 0;
    let toAddCount = 0;
    let toUpdateCount = 0;
    let toReactivateCount = 0;
    let toRestoreCount = 0;
    let toRemoveCount = 0;

    for (const row of gridRows) {
        switch (row.rowState) {
            case ReconciliationRowStates.Match:
                alignedCount++;
                break;
            case ReconciliationRowStates.TemplateOnly:
                toAddCount++;
                break;
            case ReconciliationRowStates.FlagDiff:
                toUpdateCount++;
                break;
            case ReconciliationRowStates.InactiveMatch:
                toReactivateCount++;
                break;
            case ReconciliationRowStates.DeletedMatch:
                toRestoreCount++;
                break;
            case ReconciliationRowStates.SystemOnly:
                toRemoveCount++;
                break;
        }
    }

    const needsChangesCount = toAddCount + toUpdateCount + toReactivateCount + toRestoreCount + toRemoveCount;

    return {
        alignedCount,
        needsChangesCount,
        toAddCount,
        toUpdateCount,
        toReactivateCount,
        toRestoreCount,
        toRemoveCount,
    };
}
